import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

/**
 * Blog card. When onClick is provided, click opens the article in a modal (card).
 * When to is provided, card links to that URL (e.g. on /blog page for shareable links).
 * Shows optional featured badge when post.featured is true.
 */
function BlogCard({ post, index, onClick, to }) {
  if (!post?.slug) return null;

  const cardContent = (
    <>
      {post?.featured && (
        <span className="blog-card-featured">Featured</span>
      )}
      <div className="blog-card-meta">
        <span className="blog-card-date">
          <span aria-hidden="true">📅</span> {post?.date}
        </span>
        <span className="blog-card-category">{post?.category}</span>
        <span className="blog-card-read-time">{post?.readTime}</span>
      </div>
      <h3 className="blog-card-title">{post?.title}</h3>
      <p className="blog-card-excerpt">{post?.excerpt}</p>
      {post?.tags?.length > 0 && (
        <div className="blog-card-tags">
          {post.tags.map((tag) => (
            <span key={tag} className="blog-card-tag">
              {tag}
            </span>
          ))}
        </div>
      )}
      <span className="blog-card-read-more">
        Read full article →
      </span>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="blog-card"
        aria-label={`Read article: ${post?.title}`}
      >
        {cardContent}
      </Link>
    );
  }

  const handleClick = () => {
    onClick?.(post.slug);
  };

  return (
    <button
      type="button"
      className="blog-card blog-card-button"
      onClick={handleClick}
      aria-label={`Read article: ${post?.title}`}
    >
      {cardContent}
    </button>
  );
}

export default BlogCard;
